import { Button, EButtonColorVariant, Text } from '@outdoorsyco/bonfire';

type TEmptyWishlistMessageProps = {
  content?: string;
  buttonLabel?: string;
  buttonHref?: string;
  className?: string;
  maxWidth?: string;
};

export const EmptyWishlistMessage = ({
  content,
  buttonLabel,
  buttonHref = '/rv-search',
  className = '',
}: TEmptyWishlistMessageProps) => (
  <div className={className}>
    <Text className="pb-8">{content}</Text>
    <div>
      <Button label={buttonLabel} variant={EButtonColorVariant.Primary} href={buttonHref} />
    </div>
  </div>
);
